import { Container } from "reactstrap"
import Tabs from "../../../../components/common/Tabs/Tabs"
import { useState } from "react"
import PasswordManagement from "./PasswordManagement/PasswordManagement"
import TwoFactorAuth from "./TwoFactorAuth/TwoFactorAuth"
import ManageDevices from "./ManageDevices/ManageDevices"

const Security = () => {

  const tabs = ["Password Management", "Two-factor Authentication", "Mange Devices"]
  const [activeTab, setActiveTab] = useState(tabs[0])

  return (
    <div style={{ background: "#f2f2f2", minHeight: "100vh", paddingBlock: "1rem" }}>
      <Container fluid>
        <div className="fw-semibold fs-4">Security</div>

        <Tabs tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} />

        {activeTab === "Password Management" && <PasswordManagement />}
        {activeTab === "Two-factor Authentication" && <TwoFactorAuth />}
        {activeTab === "Mange Devices" && <ManageDevices />}
      </Container>
    </div>
  )
}

export default Security
